module.exports = __webpack_public_path__ + "6ce8e4eaae2d455961a34b0d59e3ee3d.mp4";